import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Clock3, LogOut, XCircle } from "lucide-react";
import { myApprovalStatus } from "../api/onboarding";
import { useAuth } from "../context/AuthContext";
import { LangToggle, ThemeToggle } from "../components/controls/Toggles";
import { NeuButton, NeuCard } from "../components/neu/Neu";

export default function PendingApprovalPage() {
  const { t } = useTranslation();
  const { signOut, patchUser } = useAuth();
  const [state, setState] = useState(null);

  const load = async () => {
    const data = await myApprovalStatus();
    setState(data);
    patchUser({ status: data.status });
  };
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rejected = state?.status === "rejected";

  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-background px-5 py-10">
      <div className="w-full max-w-lg">
        <div className="mb-6 flex justify-end gap-2">
          <LangToggle />
          <ThemeToggle />
        </div>
        <NeuCard className="animate-rise-in text-center" data-testid="pending-card">
          {rejected ? (
            <XCircle className="mx-auto h-12 w-12 text-destructive" />
          ) : (
            <Clock3 className="mx-auto h-12 w-12 animate-pulse text-primary" />
          )}
          <h1 className="mt-5 text-2xl font-black">{rejected ? t("pending.rejectedTitle") : t("pending.title")}</h1>
          <p className="mt-3 text-sm text-muted-foreground">{t("pending.body")}</p>
          {rejected && state?.rejection_reason ? (
            <p className="mt-3 text-sm font-semibold text-destructive" data-testid="pending-reason">
              {t("pending.reason")}: {state.rejection_reason}
            </p>
          ) : null}
          <div className="mt-6 flex justify-center gap-2">
            <NeuButton data-testid="pending-refresh" onClick={load}>
              {t("pending.refresh")}
            </NeuButton>
            <NeuButton data-testid="pending-logout" className="flex items-center gap-2" onClick={signOut}>
              <LogOut className="h-4 w-4" /> {t("app.logout")}
            </NeuButton>
          </div>
        </NeuCard>
      </div>
    </div>
  );
}
